import DOMPurify from 'dompurify';
import { ParameterModel } from 'types/trackmanParameters';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

type Props = {
  visibleParameter: ParameterModel;
};

export const ParameterDefinition = observer(({ visibleParameter }: Props) => {
  const { t } = useTranslation();

  return (
    <div className='parameter-definition'>
      <h3>{t('Definition', { ns: 'trackmanParameters' })}</h3>
      <h2>{visibleParameter.title}</h2>
      {visibleParameter.definition ? <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(visibleParameter.definition) }} /> : null}
    </div>
  );
});

export default ParameterDefinition;
